import React from 'react';
import { Filter, maxLength, minLength, SearchInput } from 'react-admin';

const FiltreRecherche =props=> {

    return (
        <Filter {...props} >
            <SearchInput source="code" alwaysOn  validate={maxLength(8)} />
        </Filter>
    );

    
}

export default FiltreRecherche;